import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { get } from 'lodash';
dayjs.extend(utc);
dayjs.extend(timezone);
const FORMAT_MAP = {
    cn: {
        date: 'YYYY-MM-DD',
        time: 'YYYY-MM-DD HH:mm',
    },
    en: {
        date: 'DD MMM YYYY',
        time: 'DD MMM YYYY hh:mm a',
    },
    jp: {
        date: 'YYYY.MM.DD',
        time: 'YYYY.MM.DD HH:mm',
    },
    tw: {
        date: 'YYYY-MM-DD',
        time: 'YYYY-MM-DD HH:mm',
    },
};
export function formatDate({ date, timezone, type = 'date', }) {
    const currentLang = 'cn';
    const format = get(FORMAT_MAP, `${currentLang}.${type}`, FORMAT_MAP.cn.date);
    if (!timezone) {
        return dayjs(date).format(format);
    }
    dayjs.tz.setDefault(timezone);
    return dayjs(date).format(format);
}
